import { render } from "./PendingAccount.vue?vue&type=template&id=742c454b"
import script from "./PendingAccount.vue?vue&type=script&lang=js"
export * from "./PendingAccount.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__